
import story1_1 from '../../../assets/lotties/s1/1/1';
import story1_2 from '../../../assets/lotties/s1/2/2';
import story1_3 from '../../../assets/lotties/s1/3/3';
import story1_4 from '../../../assets/lotties/s1/4/4';
import story1_5 from '../../../assets/lotties/s1/5/5';
import story1_6 from '../../../assets/lotties/s1/6/6';

import story2_1 from '../../../assets/lotties/s2/1/1';
import story2_2 from '../../../assets/lotties/s2/2/2';
import story2_3 from '../../../assets/lotties/s2/3/3';
import story2_4 from '../../../assets/lotties/s2/4/4';
import story2_5 from '../../../assets/lotties/s2/5/5';
import story2_6 from '../../../assets/lotties/s2/6/6';

import story3_1 from '../../../assets/lotties/s3/1/1';
import story3_2 from '../../../assets/lotties/s3/2/2';
import story3_3 from '../../../assets/lotties/s3/3/3';
import story3_4 from '../../../assets/lotties/s3/4/4';
import story3_5 from '../../../assets/lotties/s3/5/5';
import story3_6 from '../../../assets/lotties/s3/6/6';

export const updateCurrentScene = (storyId, currentScene, scene) => {
  switch(`story${storyId}_${scene}`) {
    case 'story1_1': 
        currentScene = story1_1;
        break;
    case 'story1_2': 
        currentScene = story1_2;
        break;
    case 'story1_3': 
        currentScene = story1_3;
        break;
    case 'story1_4': 
        currentScene = story1_4;
        break;
    case 'story1_5': 
        currentScene = story1_5;
        break;
    case 'story1_6': 
        currentScene = story1_6;
        break;

    case 'story2_1': 
        currentScene = story2_1;
        break;
    case 'story2_2': 
        currentScene = story2_2;
        break;
    case 'story2_3': 
        currentScene = story2_3;
        break;
    case 'story2_4': 
        currentScene = story2_4;
        break;
    case 'story2_5': 
        currentScene = story2_5;
        break;
    case 'story2_6': 
        currentScene = story2_6;
        break;

    case 'story3_1': 
    currentScene = story3_1;
        break;
    case 'story3_2': 
        currentScene = story3_2;
        break;
    case 'story3_3': 
        currentScene = story3_3;
        break;
    case 'story3_4': 
        currentScene = story3_4;
        break;
    case 'story3_5': 
        currentScene = story3_5;
        break;
    case 'story3_6': 
        currentScene = story3_6;
        break;

    default: currentScene = story1_1;
  }
  return currentScene;
}

export const story1_actions = ['', 'Seek support with your local migration office', 'Go back home'];
export const story2_actions = ['', 'Seek support with your local migration office', 'Go back home', 'Start the reintegration process', 'Reunite with the family'];
export const story3_actions = ['Seek support with your local migration office', 'Go back home', 'Start the reintegration process', 'Talk about your needs'];

export const setStoryActions = (storyId) => {

    switch (storyId) {
        case '1':
            return story1_actions;
        case '2':
            return story2_actions;
        case '3':
            return story3_actions;
        default:
            return story1_actions;
    }
  }

